import React, { useEffect, useState } from "react";
import "./confirmRegistration.scss";

import HeaderRegistration from "../registration/components/headerRegistration/HeaderRegistration";
import { Button, Stack } from "react-bootstrap";
import { t } from "i18next";
import { useNavigate, useParams } from "react-router-dom";
import { verifyAccountWS } from "./api/confirmRegistrationApi";

const ConfirmRegistration = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [error, setError] = useState(true);

  useEffect(() => {
    verifyAccountWS({ id })
      .then((res) => {
        setShow(true);
        setError(false);
      })
      .catch((err) => {
        setShow(true);
        setError(true);
      });
  }, []);

  console.log(id);

  return (
    <>
      <div className="min-vh-100 w-100 d-flex justify-content-center align-items-center container-confirm-registration">
        {show ? (
          <div className="confirm-registration">
            <Stack gap={3}>
              <HeaderRegistration
                title={
                  !error
                    ? t("confirm_registration.title")
                    : t("confirm_registration.title_error")
                }
                subtitle={
                  !error
                    ? t("confirm_registration.subtitle")
                    : t("confirm_registration.subtitle_error")
                }
              />
              <Button
                variant="light"
                size="md"
                onClick={() => {
                  navigate("../login");
                }}
              >
                {t("login.title")}
              </Button>
            </Stack>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ConfirmRegistration;
